import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70bd5495"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pt-24 -md:pt-16 p-5" }
const _hoisted_2 = { class: "px-6 py-4" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title text-left pb-5" }, "Contratos", -1))
const _hoisted_4 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8\" data-v-70bd5495><div class=\"py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8\" data-v-70bd5495><div class=\"shadow overflow-hidden border-b border-gray-200 sm:rounded-lg\" data-v-70bd5495><table id=\"example\" class=\"stripe hover\" style=\"width:100%;padding-top:1em;padding-bottom:1em;\" data-v-70bd5495><caption data-v-70bd5495></caption><thead data-v-70bd5495><tr data-v-70bd5495><th scope=\"col\" data-priority=\"1\" data-v-70bd5495>Situação</th><th scope=\"col\" data-priority=\"2\" data-v-70bd5495>Código do contrato</th><th scope=\"col\" data-priority=\"2\" data-v-70bd5495>Produto</th><th scope=\"col\" data-priority=\"2\" data-v-70bd5495>Data de renovação</th><th scope=\"col\" data-priority=\"2\" data-v-70bd5495>Data do contrato</th><th scope=\"col\" data-priority=\"2\" data-v-70bd5495>Dia do vencimento</th></tr></thead><tbody data-v-70bd5495><tr data-v-70bd5495><td data-v-70bd5495><div class=\"p-2 text-center text-white rounded-lg bg-green-500\" data-v-70bd5495> Ativo </div></td><td data-v-70bd5495>3043</td><td data-v-70bd5495>Manager SaaS Ilimitado</td><td data-v-70bd5495>26/06/2022</td><td data-v-70bd5495>26/06/2022</td><td data-v-70bd5495>12</td></tr></tbody></table></div></div></div>", 1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "py-8 pt-3" }
const _hoisted_8 = { class: "block md:flex gap-5" }
const _hoisted_9 = { class: "block" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, " Descrição ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = {
  key: 0,
  class: "text-red-500 text-xs"
}
const _hoisted_13 = { class: "gap-5 flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Select = _resolveComponent("Select")!
  const _component_Input = _resolveComponent("Input")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_Button = _resolveComponent("Button")!
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Toast = _resolveComponent("Toast")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (!_ctx.registering)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
        : _createCommentVNode("", true),
      (_ctx.registering)
        ? (_openBlock(), _createBlock(_component_Card, {
            key: 1,
            class: "pt-8 px-6 m-5 mx-auto",
            width: "max-w-min",
            title: "Cadastrar nova mensagem",
            orientation: "flex-col"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_Select, {
                    selected: "Produto",
                    label: "Produto",
                    options: () => _ctx.selectValues,
                    display: "descricao",
                    itemId: "value",
                    labelClass: "p-0 text-left",
                    event: "update:editValue",
                    class: "w-6/6 md:w-3/6",
                    "onUpdate:editValue": _ctx.changeType,
                    incorrectMessage: _ctx.validations.package,
                    isIncorrect: _ctx.validations.package != ''
                  }, null, 8, ["options", "onUpdate:editValue", "incorrectMessage", "isIncorrect"]),
                  _createVNode(_component_Input, {
                    label: "Título",
                    class: "w-6/6 md:w-3/6",
                    incorrectMessage: _ctx.validations.titulo,
                    isIncorrect: _ctx.validations.titulo != '',
                    labelClass: "p-0 text-left",
                    modelValue: _ctx.mensagem.titulo,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.mensagem.titulo) = $event))
                  }, null, 8, ["incorrectMessage", "isIncorrect", "modelValue"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _hoisted_11,
                  _withDirectives(_createElementVNode("textarea", {
                    class: "border outline-none border-gray-300 rounded-lg w-full p-3 mb-3 custom-input",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.mensagem.descricao) = $event)),
                    rows: "5"
                  }, null, 512), [
                    [_vModelText, _ctx.mensagem.descricao]
                  ])
                ]),
                _createVNode(_component_DatePicker, {
                  modelValue: _ctx.mensagem.dates,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.mensagem.dates) = $event)),
                  "is-range": "",
                  columns: _ctx.width() > 768 ? 2 : 1,
                  class: _normalizeClass(["my-1", _ctx.validations.dates != '' ? 'border-red-500' : ''])
                }, null, 8, ["modelValue", "columns", "class"]),
                (_ctx.validations.dates != '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, " Informe as datas de visibilidade da mensagem! "))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_Button, {
                    label: "Voltar",
                    onClick: _ctx.back,
                    class: "p-0 my-4 w-full divide-transparent",
                    width: "w-min"
                  }, null, 8, ["onClick"]),
                  _createVNode(_component_PrimaryButton, {
                    isLoading: _ctx.loading,
                    label: "Enviar",
                    onClick: _ctx.send,
                    class: "p-0 my-4 w-full divide-transparent text-white",
                    width: "w-full",
                    type: "submit"
                  }, null, 8, ["isLoading", "onClick"])
                ])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_Toast, {
        label: _ctx.message,
        hidden: _ctx.hidden,
        onHide: _ctx.hide
      }, null, 8, ["label", "hidden", "onHide"])
    ])
  ]))
}